var _path, _path2, _path3, _polygon, _path4, _path5, _path6, _path7, _path8, _circle, _path9, _path10, _path11, _polygon2, _rect, _rect2, _rect3, _rect4, _polygon3, _rect5, _rect6, _rect7, _rect8, _path12, _path13, _polygon4, _path14, _rect9, _rect10, _rect11, _path15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 783.86048,
    height: 582,
    viewBox: "0 0 783.86048 582",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "e5e37569-bd8f-45f7-97a1-e817a6c74118-94",
    "data-name": "Path 133",
    d: "M255.36793,631.64967a383.36323,383.36323,0,0,0,17.91035,105.97359c.242.79624.51068,1.5805.77208,2.37674h66.83227c-.07017-.71395-.14277-1.51034-.213-2.37674C336.2138,686.39476,361.67072,378.31969,392.38937,325,389.69805,329.32523,250.18605,468.8735,255.36793,631.64967Z",
    transform: "translate(-208.06976 -159)",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "b4ba0d08-0a29-4ca1-8d08-8a7c96f19f4d-95",
    "data-name": "Path 134",
    d: "M260.383,737.62326c.55906.79624,1.14,1.59262,1.73539,2.37674h50.13933c-.38-.67776-.82046-1.474-1.33114-2.37674-8.28233-14.94795-32.79773-59.64156-55.55358-105.97359-24.44524-49.79084-46.89124-101.46946-45.001-120.1736C209.7862,515.69212,192.8634,644.29342,260.383,737.62326Z",
    transform: "translate(-208.06976 -159)",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M474.79946,557.376a11.57466,11.57466,0,0,0-.33446,1.79163l-48.27965,25.35542-11.21022-7.05979-12.86572,15.52563,18.6309,14.42661a8.79679,8.79679,0,0,0,10.55607.16166l50.19421-36.4644a11.54261,11.54261,0,1,0-6.69113-13.73676Z",
    transform: "translate(-208.06976 -159)",
    fill: "#9e616a"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "324.938 570.183 334.619 563.957 315.213 523.657 300.926 532.845 324.938 570.183",
    fill: "#9e616a"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M528.50644,727.61018l19.06373-12.26026.00077-.0005a14.44521,14.44521,0,0,1,19.9618,4.33632l.25388.3948L536.57373,740.154Z",
    transform: "translate(-208.06976 -159)",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M393.5396,659.9591,467.847,612.38389s13.6529-1.31776,21.84685,14.83091l49.489,71.08766-21.11406,14.287-54.91562-57.0219L425.47,692.83556s55.51979-9.10476,53.64224,27.50747c-1.49,29.05561-77.47721,19.0889-108.78065,13.737a41.049,41.049,0,0,1-28.76413-19.691c-3.35731-5.823-5.162-12.43454-2.34211-18.68478C346.745,679.03693,393.5396,659.9591,393.5396,659.9591Z",
    transform: "translate(-208.06976 -159)",
    fill: "#2f2e41"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M356.70251,699.71977l-21.414-4.33358,6.10226-105.10156,24.63964-30.18015,14.68-2.599a17.73623,17.73623,0,0,1,20.29162,12.84032l6.47058,23.63806c10.97881,18.58894-4.4012,40.14272-5.81968,42.05832l.7992,32.5986Z",
    transform: "translate(-208.06976 -159)",
    fill: "#1976d2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M376.64164,564.22136l1.35866-4.80645s14.74466-10.86772,37.27527,17.29553l-10.79592,19.24489-23.46937-.93877Z",
    transform: "translate(-208.06976 -159)",
    fill: "#1976d2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M410.56031,526.81823c4.17705,17.12359-12.28823,18.39594-31.81983,23.16039s-34.7333,11.21679-38.91034-5.90681-3.84691-49.36307,23.78391-56.1032C392.19679,480.99627,406.38326,509.69464,410.56031,526.81823Z",
    transform: "translate(-208.06976 -159)",
    fill: "#2f2e41"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 164.74048,
    cy: 367.18152,
    r: 24.49513,
    fill: "#9e616a"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M344.74518,530.55411v0l9.41231-2.296,1.31618-12.63979,3.66649,11.42434,4.4987-1.09739.76781-7.37322,2.13891,6.66417,33.42727-8.15409v0a25.93023,25.93023,0,0,0-31.33665-19.04644l-4.84458,1.18177A25.93021,25.93021,0,0,0,344.74518,530.55411Z",
    transform: "translate(-208.06976 -159)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M414.76053,647.31063a11.57427,11.57427,0,0,0-1.72177.59773L367.0839,618.549l.57376-13.23557L347.796,601.83676l-3.2928,23.33226a8.7968,8.7968,0,0,0,5.09274,9.24775l56.55178,25.51485a11.54262,11.54262,0,1,0,8.6128-12.621Z",
    transform: "translate(-208.06976 -159)",
    fill: "#9e616a"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M369.74707,564.90235l-3.46321-4.36586s-13.90623-4.4791-21.41643,14.2964-.46938,37.08162-.46938,37.08162l32.85713,2.81632,2.34693-30.51019Z",
    transform: "translate(-208.06976 -159)",
    fill: "#1976d2"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "527.283 130.684 783.86 130.684 783.86 214.914 774.142 214.914 774.142 236.943 752.112 214.914 527.283 214.914 527.283 130.684",
    fill: "#999999"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 534.40966,
    y: 138.88597,
    width: 242.32364,
    height: 67.38411,
    fill: "#4d4d4d"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 553.8962,
    y: 158.55919,
    width: 116.67262,
    height: 3.54072,
    fill: "#1976d2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 553.8962,
    y: 170.80767,
    width: 203.35058,
    height: 3.54072,
    fill: "#999999"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 553.8962,
    y: 183.05615,
    width: 203.15145,
    height: 3.54072,
    fill: "#999999"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "630.506 0 373.928 0 373.928 84.23 383.647 84.23 383.647 106.26 405.676 84.23 630.506 84.23 630.506 0",
    fill: "#999999"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 381.05497,
    y: 8.20248,
    width: 242.32363,
    height: 67.38412,
    fill: "#4d4d4d"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 402.48528,
    y: 28.52363,
    width: 116.67262,
    height: 3.54072,
    fill: "#1976d2"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 402.48528,
    y: 40.7721,
    width: 203.35059,
    height: 3.54072,
    fill: "#999999"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 402.48528,
    y: 53.02057,
    width: 203.15146,
    height: 3.54072,
    fill: "#999999"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M520.93445,538.645h-.45422v-12.4432A7.20178,7.20178,0,0,0,513.27845,519H486.91584a7.20178,7.20178,0,0,0-7.2018,7.20177v68.26438a7.20178,7.20178,0,0,0,7.20178,7.20179h26.3626a7.20178,7.20178,0,0,0,7.2018-7.20176V547.50227h.45423Z",
    transform: "translate(-208.06976 -159)",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M513.569,520.87366h-3.44119a2.55516,2.55516,0,0,1-2.36575,3.52019h-15.1028a2.55518,2.55518,0,0,1-2.36574-3.5202h-3.21408a5.37822,5.37822,0,0,0-5.37822,5.37821v68.16421a5.37821,5.37821,0,0,0,5.37821,5.37822H513.569a5.37821,5.37821,0,0,0,5.37822-5.37821h0V526.25186A5.3782,5.3782,0,0,0,513.569,520.87366Z",
    transform: "translate(-208.06976 -159)",
    fill: "#4d4d4d"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "598.506 248.549 283.441 248.549 283.441 351.98 295.375 351.98 295.375 379.03 322.426 351.98 598.506 351.98 598.506 248.549",
    fill: "#4d4d4d"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M502.445,540.44434V511.97949H490.5107V406.54883H807.5754V511.97949H530.91012Zm-9.93433-30.46485H504.445v25.63672l25.63647-25.63672H805.5754V408.54883H492.5107Z",
    transform: "translate(-208.06976 -159)",
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 318.5081,
    y: 283.5746,
    width: 143.26813,
    height: 4.34783,
    fill: "#1976d2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 318.5081,
    y: 298.61512,
    width: 249.70433,
    height: 4.34783,
    fill: "#999999"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 318.5081,
    y: 313.65563,
    width: 249.45981,
    height: 4.34783,
    fill: "#999999"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M636.96176,741h-381a1,1,0,0,1,0-2h381a1,1,0,1,1,0,2Z",
    transform: "translate(-208.06976 -159)",
    fill: "#3f3d56"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeDark);
export default __webpack_public_path__ + "static/media/home_dark.103c8310447871d36e5cda18cd1dc9a8.svg";
export { ForwardRef as ReactComponent };